/**
 * Synergy Gifts - visual font picker.
 *
 * Minimog's "Custom field" block can only render a plain <select> of text
 * options, so a font dropdown that shows a sample of each font is not
 * something the theme can do on its own. This upgrades that select into a
 * grid of sample cards while leaving the original control in the form, so the
 * chosen font still posts as the same line-item property and still shows on
 * the order.
 *
 * The font list lives in Admin > Content > Metaobjects > Personalisation font,
 * so fonts can be added or swapped without touching code. With no entries the
 * plain dropdown is left exactly as it was.
 */
(function () {
  'use strict';

  var LABEL_MATCH = /font/i;
  var BUILT = 'sgFontPickerBuilt';

  function fonts() {
    var el = document.getElementById('sg-font-data');
    if (!el) return [];
    try {
      return (JSON.parse(el.textContent) || []).filter(function (f) {
        return f && f.label;
      });
    } catch (e) {
      return [];
    }
  }

  function labelText(field) {
    var l = field.querySelector('.m-product-option--label');
    return l ? l.textContent.trim() : '';
  }

  function card(font, name, index) {
    var li = document.createElement('li');
    li.className = 'sg-fontpick__item';

    var input = document.createElement('input');
    input.type = 'radio';
    input.className = 'sg-fontpick__radio';
    input.name = name;
    input.value = font.label;
    // Index, not anything from the font record: two fonts sharing a handle (or
    // a blank one) would otherwise collide and every label would point at the
    // first radio, so every card would select the first font.
    input.id = name + '-' + index;

    var lab = document.createElement('label');
    lab.className = 'sg-fontpick__card';
    lab.setAttribute('for', input.id);

    var sample = document.createElement('span');
    sample.className = 'sg-fontpick__sample';
    if (font.image) {
      var img = document.createElement('img');
      img.src = font.image;
      img.alt = font.label + ' sample';
      img.loading = 'lazy';
      img.width = font.width || 320;
      img.height = font.height || 120;
      sample.appendChild(img);
    } else {
      // No sample uploaded yet - show the name in a script face as a stand-in.
      sample.classList.add('sg-fontpick__sample--text');
      sample.textContent = font.label;
    }

    var cap = document.createElement('span');
    cap.className = 'sg-fontpick__name';
    cap.textContent = font.label;

    lab.appendChild(sample);
    lab.appendChild(cap);
    if (font.note) {
      var note = document.createElement('span');
      note.className = 'sg-fontpick__note';
      note.textContent = font.note;
      lab.appendChild(note);
    }
    li.appendChild(input);
    li.appendChild(lab);
    return { li: li, input: input };
  }

  function build(field, list) {
    var select = field.querySelector('select');
    if (!select || field.dataset[BUILT]) return;
    field.dataset[BUILT] = '1';

    // The metaobject list is the source of truth: rebuild the options from it
    // so the placeholder names in the theme editor can never drift from what
    // the customer is shown.
    var placeholder = select.querySelector('option[value=""]');
    select.innerHTML = '';
    if (placeholder) select.appendChild(placeholder);
    list.forEach(function (f) {
      var o = document.createElement('option');
      o.value = f.label;
      o.textContent = f.label;
      select.appendChild(o);
    });
    select.value = '';

    var wrap = document.createElement('div');
    wrap.className = 'sg-fontpick';
    var ul = document.createElement('ul');
    ul.className = 'sg-fontpick__grid';
    wrap.appendChild(ul);

    var group = 'sg-font-' + (select.id || Math.random().toString(36).slice(2));
    list.forEach(function (f, i) {
      var c = card(f, group, i);
      c.input.addEventListener('change', function () {
        select.value = f.label;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        select.setCustomValidity('');
      });
      ul.appendChild(c.li);
    });

    select.classList.add('sg-fontpick__native');
    select.insertAdjacentElement('afterend', wrap);

    // A required select that is hidden outright cannot be focused, and the
    // browser then refuses to submit with no message at all. Keeping it
    // rendered but transparent behind the cards means the usual "please
    // select" bubble still appears, over the picker.
    if (select.hasAttribute('required')) {
      field.classList.add('sg-fontpick--required');
    }
  }

  function scan() {
    var list = fonts();
    if (!list.length) return;
    var fields = document.querySelectorAll(
      '.m-product-custom-field[data-product-custom-field="select"]'
    );
    Array.prototype.forEach.call(fields, function (field) {
      if (LABEL_MATCH.test(labelText(field))) build(field, list);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  // Quick view and the theme editor swap the product form in after load.
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('quickview:loaded', scan);
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      if (muts[i].addedNodes.length) { scan(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
